import { useNavigate, useLocation } from 'react-router-dom'
import { Home, LogIn, LayoutDashboard } from 'lucide-react'
import { useAuthStore } from '../../../stores/authStore'

export function IdBottomShell() {
  const { isAuthenticated } = useAuthStore()
  const navigate = useNavigate()
  const location = useLocation()

  const items = [
    { icon: Home, label: 'Home', path: '/' },
    isAuthenticated
      ? { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' }
      : { icon: LogIn, label: 'Sign In', path: '/login' },
  ]

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden flex items-center justify-around h-14 backdrop-blur-xl bg-[var(--lukhas-deep-space)]/90 border-t border-white/5"
      role="navigation"
      aria-label="Mobile navigation"
    >
      {items.map(({ icon: Icon, label, path }) => {
        const active = location.pathname === path
        return (
          <button
            key={path}
            onClick={() => navigate(path)}
            className={[
              'flex flex-col items-center gap-0.5 px-4 py-1 rounded-lg transition-colors',
              active
                ? 'text-[var(--domain-id-purple)]'
                : 'text-[var(--lukhas-text-secondary)] hover:text-[var(--lukhas-text-primary)]',
            ].join(' ')}
            aria-label={label}
            aria-current={active ? 'page' : undefined}
          >
            <Icon size={20} />
            <span className="text-[10px] font-medium">{label}</span>
          </button>
        )
      })}
    </nav>
  )
}
